<template>
  <div class="">
    <Dialog :group="reply?.id" v-model:visible="isReplyExpanded" modal :showHeader="false" dismissableMask
      class="custom-dialogForum max-w-[90%] lg:max-w-[1113px] flex flex-col w-full mb-4 overflow-hidden">
      <div class="p-5 border-l-8 rounded-md custom-quill" :class="`${reply?.comment
        ? 'bg-h-primary-50 border border-h-primary-100'
        : 'bg-h-neutral-100 border border-h-neutral-200 text-h-neutral-700 font-normal	'
        }`">
        <button class="absolute right-5 top-5" @click="closeModalReply">
          <span class="pi pi-times" />
        </button>
        <header class="flex mb-6">
          <div v-if="!reply?.authorComment?.photoProfile">
            <img class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer" src="@/assets/images/user-topic.svg"
              alt="user" />
          </div>
          <div v-else-if="reply?.authorComment?.photoProfile">
            <img class="object-cover w-12 h-12 mr-6 rounded-full cursor-pointer"
              :src="reply?.authorComment?.photoProfile.path" alt="user" />
          </div>
          <span class="flex flex-col gap-2">
            <p class="text-base font-bold text-h-neutral-700">
              {{
                 reply?.authorComment?.name + ":"
              }}
            </p>
            <p v-if="reply?.created" class="text-xs font-semibold text-h-neutral-700">
              {{
                $t("labels.generic", {
                  pt: "Publicado",
                  en: "Published",
                })
              }}
              {{ timeSinceCreation }}
            </p>
          </span>
        </header>

        <p v-if="reply?.comment" v-html="reply?.comment" class="ql-editor text-sm text-h-neutral-700"></p>
        <span v-else>
          <i>
            {{
              $t("labels.generic", {
                pt: "Comentário excluído.",
                en: "Comment deleted.",
              })
            }}
          </i>
        </span>
      </div>
    </Dialog>
    <div v-if="reply !== null" class="relative flex flex-col w-full gap-2 p-3 mb-4 border-l-8 rounded cursor-pointer" :class="`${reply?.comment
      ? 'bg-h-primary-50 border border-h-primary-100'
      : 'bg-h-neutral-100 border border-h-neutral-200 text-h-neutral-700 font-normal	'
      }`" @click="expandModalReply">
      <h6 class="text-h-primary-600 font-extrabold !text-[14px] cursor-pointer">
        {{
          reply?.authorComment?.name
            ? reply?.authorComment?.name + ":"
            : $t("forum.comment.authorDeleted") + ":"
        }}
      </h6>
      <div
        class="relative after:content[' '] after:absolute after:top-0 after:left-0 after:cursor-pointer after:w-full after:h-full after:bg-transparent">
        <p v-if="reply?.comment !== null" v-html="reply?.comment"
          class="text-sm text-h-neutral-700 !whitespace-pre-wrap !truncate !line-clamp-3 md:!line-clamp-2 !inline-block !text-wrap ql-editor">
        </p>
        <span v-else>
          <i>
            {{
              $t("labels.generic", {
                pt: "Comentário excluído.",
                en: "Comment deleted.",
              })
            }}
          </i>
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Reply } from "@/models/comment.model";
import moment from "moment";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "comment-answer",
  data() {
    return {
      isReplyExpanded: false,
    };
  },
  props: {
    reply: {} as PropType<Reply>,
  },
  methods: {
    expandModalReply(): void {
      if(this.reply?.id === null || this.reply === undefined) return;
      this.isReplyExpanded = true;
    },
    closeModalReply(): void {
      this.isReplyExpanded = false;
    },
  },
  computed: {
    timeSinceCreation(): string {
      //TODO - when location language activated use navigator.language
      moment.locale("pt-br");
      return moment(this.reply?.created).add(3, "hour").fromNow();
    },
  }
});
</script>
